import gql from 'graphql-tag';

export const UPDATE_SHOP_PROP = gql`
	mutation updateShopProp($id: ID!, $input: updateShopProp__input!) {
		updateShopProp(id: $id, input: $input) {
			id
		}
	}
`;

export const SWITCH_CAMPAIGN_STATUS = gql`
	mutation SwitchCampaignStatus($id: ID!, $input: UpdateCampaignInput!) {
		updateCampaign(id: $id, input: $input) {
			id
			name
			active
			target {
				type
			}
			settings {
				type
			}
		}
	}
`;

export const CREATE_CAMPAIGN_MUTATION = gql`
	mutation CreateCampaign($input: NewCampaignInput!) {
		createCampaign(input: $input) {
			id
		}
	}
`;

export const UPDATE_CAMPAIGN_MUTATION = gql`
	mutation UpdateCampaign($id: ID!, $input: UpdateCampaignInput!) {
		updateCampaign(id: $id, input: $input) {
			id
		}
	}
`;

export const REMOVE_CAMPAIGN_MUTATION = gql`
	mutation RemoveCampaign($id: ID!) {
		removeCampaign(id: $id) {
			id
		}
	}
`;

export const SAVE_SHOP_SETTINGS = gql`
	mutation SaveShopSettings($id: ID!, $input: ShopSettings__input!) {
		updateShopSettings(id: $id, input: $input) {
			id
		}
	}
`;

export const SAVE_PLAN_SETTINGS = gql`
	mutation SavePlanSettings($id: ID!, $input: PlanSettings__input!) {
		updatePlanSettings(id: $id, input: $input) {
			id
		}
	}
`;
